module.exports = __webpack_public_path__ + "static/media/pic1.3da4de13.png";